import { GenericConfirmationDialogStyles } from '@/components/Analysis/shared/GeneriConfirmationDialog/styles';
import { Modal, Paper, Typography } from '@mui/material';

type Props = {
  open: boolean;
};

export const FileFixingUploadLoadingModal = ({ open }: Props) => {
  return (
    <Modal open={open}>
      <Paper
        sx={{
          ...GenericConfirmationDialogStyles,
          width: '50vw',
          height: '60vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <img src="/assets/abyss-logo-black.svg" alt="loading" height={64} width={64} />
        <Typography fontSize={'13px'} fontWeight={400}>
          Uploading the file.This may take a few seconds.
        </Typography>
      </Paper>
    </Modal>
  );
};
